import { data } from '../../svg/Address/data';
import { makeIcon } from '../makeIcon';

export const Address = makeIcon(data, 'address', 'Address');

export default Address;
